import { Soundfont, useAudioEngine, useInstrument, type InstrumentName } from '@tunasong/audio-ui'
import { type NoteEvent } from '@tunasong/music-lib'
import { useMemo } from 'react'

/** Hook to provide MIDI integration for keyboards */
export const usePlayNotes = (instrumentName: InstrumentName = 'acoustic_grand_piano') => {
  const engine = useAudioEngine()

  const baseInstrument = useMemo(
    () => new Soundfont(engine.mixer.context, instrumentName),
    [engine.mixer.context, instrumentName]
  )
  useInstrument('base', baseInstrument)

  const playNotes = (notes: NoteEvent[]) => {
    engine.play(notes)
  }
  const playNoteSequence = (notes: NoteEvent[]) => {
    engine.playSequence(notes)
  }

  return { playNotes, playNoteSequence }
}
